import * as actionType from "./actionTypes";
import { createReducer, updateObject } from "../../utils/reducerUtils";

/* State shape same as initial state
*/
const initialState = {
  //Library home: { firstName, collections, newClasses, recent }
  overview: null,
  //By slug: { collection, classes } or { locked: true, collection, unlockedBy }
  collections: {},
  //My account: { current, programs, payments, subscriptionPlans, trialAvailable }
  membership: null,
};

const setOverview = (state, action) => (
  updateObject(state, {
    overview: action.overview,
  })
);

const setCollection = (state, action) => (
  updateObject(state, {
    collections: updateObject(state.collections, {
      [action.slug]: action.data,
    }),
  })
);

//Tick the class off in every library it appears in
const markWatched = (state, action) => {
  const collections = {};
  for (const slug in state.collections) {
    const data = state.collections[slug];
    collections[slug] = data.classes ? updateObject(data, {
      classes: data.classes.map((c) => ((c.id === action.classId) ? { ...c, watched: true } : c)),
    }) : data;
  }
  return updateObject(state, {
    collections,
  });
};

const setMembership = (state, action) => (
  updateObject(state, {
    membership: action.membership,
  })
);

const reducer = createReducer(initialState, {
  [actionType.SET_OVERVIEW]: setOverview,
  [actionType.SET_COLLECTION]: setCollection,
  [actionType.MARK_WATCHED]: markWatched,
  [actionType.SET_MEMBERSHIP]: setMembership,
});

export default reducer;

// SELECTORS
export const getOverview = (state) => state.overview;
export const getCollection = (state) => (
  (slug) => state.collections[slug] || null
);
export const getMembership = (state) => state.membership;
